import { Button } from '@simplywallst/ui-core';
import styled from 'styled-components';

export const FeatureList = styled('ul')`
  list-style-type: disc;
  margin: ${({ theme }) => `0 0 ${theme.x2spacePx}px ${theme.x3spacePx}px`};
`;

export const PlanBtn = styled(Button)`
  margin: auto;
  ${({ theme }) => theme.typography.tinyStrong}
  &:disabled {
    background-color: ${({ theme }) => theme.color.spaceGrayRGBA(0.1)};
    color: ${({ theme }) => theme.color.spaceGray};
    opacity: 1;
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.color.spaceGrayRGBA(0.2)};
  }
`;
